<div class="rcc-pdf-report-info">

  <!-- ── Dark header banner ── -->
  <div class="rcc-pdf-report-info__header">
    <h1 class="rcc-pdf-report-info__title">{{ content?.pagetitle }}</h1>
    <p class="rcc-pdf-report-info__subtitle" *ngIf="printClientName">
      {{ content?.preparedfor }} {{ content?.for }} {{ printClientName }} {{ content?.on }} {{ printDate }}
    </p>
    <p class="rcc-pdf-report-info__subtitle" *ngIf="!printClientName">
      {{ content?.preparedfor }} {{ content?.on }} {{ printDate }}
    </p>
  </div>

  <!-- ── White body ── -->
  <div class="rcc-pdf-report-info__body">

    <h2 class="rcc-pdf-report-info__page-heading">{{ content?.infosectionheader }}</h2>

    <!-- Two-column tax info -->
    <div class="rcc-pdf-report-info__tax-columns">

      <!-- Current tax column -->
      <div class="rcc-pdf-report-info__tax-column">
        <h3 class="rcc-pdf-report-info__column-header" [innerHTML]="content?.yourcurrenttaxinfo"></h3>

        <p class="rcc-pdf-report-info__row">
          {{ clientInfoTaxContent?.subheader1 }}: <strong>{{ inputData.currentAnnualIncome | currency:'USD':'symbol':'1.0-0' }}</strong>
        </p>
        <p class="rcc-pdf-report-info__row">
          {{ clientInfoTaxContent?.taxfilingstatus }}: <strong>{{ currentFilingStatusLabel }}</strong>
        </p>
        <p class="rcc-pdf-report-info__row">
          {{ clientInfoTaxContent?.federalrate }}: <strong>{{ getPercent(inputData.currentFederalTaxRate) }}</strong>
        </p>
        <p class="rcc-pdf-report-info__row" *ngIf="!stateTaxRatesFromBXR">
          {{ content?.stateandlocaltaxrate }}: <strong>{{ getPercent(inputData.currentStateTaxRate) }}</strong>
        </p>
        <ng-container *ngIf="stateTaxRatesFromBXR">
          <p class="rcc-pdf-report-info__row">
            {{ rothConvDetailsContent?.stateOfTaxation }}: <strong>{{ getStateDisplayName(inputData.currentStateOfTaxation) }}</strong>
          </p>
          <p class="rcc-pdf-report-info__row">
            {{ rothConvDetailsContent?.stateTaxRate }}: <strong>{{ getPercent(inputData.currentStateTaxStatic) }}</strong>
          </p>
          <p class="rcc-pdf-report-info__row">
            {{ rothConvDetailsContent?.localTaxRate }}: <strong>{{ getPercent(inputData.currentLocalTax) }}</strong>
          </p>
        </ng-container>
      </div>

      <!-- Future tax column -->
      <div class="rcc-pdf-report-info__tax-column">
        <h3 class="rcc-pdf-report-info__column-header" [innerHTML]="content?.yourfuturetaxinfo"></h3>

        <p class="rcc-pdf-report-info__row">
          {{ clientInfoTaxContent?.subheader2 }}: <strong>{{ inputData.futureAnnualIncome | currency:'USD':'symbol':'1.0-0' }}</strong>
        </p>
        <p class="rcc-pdf-report-info__row">
          {{ clientInfoTaxContent?.taxfilingstatus }}: <strong>{{ futureFilingStatusLabel }}</strong>
        </p>
        <p class="rcc-pdf-report-info__row">
          {{ clientInfoTaxContent?.federalrate }}: <strong>{{ getPercent(inputData.futureFederalTaxRate) }}</strong>
        </p>
        <p class="rcc-pdf-report-info__row" *ngIf="!stateTaxRatesFromBXR">
          {{ content?.stateandlocaltaxrate }}: <strong>{{ getPercent(inputData.futureStateTaxRate) }}</strong>
        </p>
        <ng-container *ngIf="stateTaxRatesFromBXR">
          <p class="rcc-pdf-report-info__row">
            {{ rothConvDetailsContent?.stateOfTaxation }}: <strong>{{ getStateDisplayName(inputData.futureStateOfTaxation) }}</strong>
          </p>
          <p class="rcc-pdf-report-info__row">
            {{ rothConvDetailsContent?.stateTaxRate }}: <strong>{{ getPercent(inputData.futureStateTaxStatic) }}</strong>
          </p>
          <p class="rcc-pdf-report-info__row">
            {{ rothConvDetailsContent?.localTaxRate }}: <strong>{{ getPercent(inputData.futureLocalTax) }}</strong>
          </p>
        </ng-container>
      </div>

    </div>

    <!-- Roth conversion details -->
    <div class="rcc-pdf-report-info__conv-details">
      <h2 class="rcc-pdf-report-info__column-header">Roth conversion <strong>details</strong></h2>

      <p class="rcc-pdf-report-info__row">
        {{ rothConvDetailsContent?.rothConvAmnt }}: <strong>{{ inputData.rothConversionAmount | currency:'USD':'symbol':'1.0-0' }}</strong>
      </p>

      <p class="rcc-pdf-report-info__row">
        {{ rothConvDetailsContent?.yearsUntilDist }}: <strong>{{ inputData.yearsUntilDist }}</strong>
      </p>

      <p class="rcc-pdf-report-info__row rcc-pdf-report-info__row--no-border">
        {{ content?.conversiontaxpaymenttype }}: <strong>{{ paymentMethodLabel }}</strong>
      </p>

      <!-- Conditional sub-fields based on payment type -->
      <div class="rcc-pdf-report-info__sub-fields">

        <!-- Annual return: ALWAYS shown -->
        <p class="rcc-pdf-report-info__sub-row">
          {{ rothConvDetailsContent?.annualReturn }}: <strong>{{ getPercent(inputData.annualReturn) }}</strong>
        </p>

        <!-- Cash yield: shown only if Cash payment -->
        <ng-container *ngIf="showCashFields">
          <p class="rcc-pdf-report-info__sub-row">
            {{ rothConvDetailsContent?.cashYield }}: <strong>{{ getPercent(inputData.cashYield) }}</strong>
          </p>
        </ng-container>

        <!-- Dividend tax rate, Capital gains tax rate, Dividend yield: shown only if Tax-efficient -->
        <ng-container *ngIf="showTaxableAccountFields">
          <p class="rcc-pdf-report-info__sub-row">
            {{ rothConvDetailsContent?.dividendRate }}: <strong>{{ getPercent(inputData.dividendTaxRate) }}</strong>
          </p>
          <p class="rcc-pdf-report-info__sub-row">
            {{ rothConvDetailsContent?.capitalGainsRate }}: <strong>{{ getPercent(inputData.capitalGainsTaxRate) }}</strong>
          </p>
          <p class="rcc-pdf-report-info__sub-row">
            {{ rothConvDetailsContent?.dividendYield }}: <strong>{{ getPercent(inputData.dividendYield) }}</strong>
          </p>
        </ng-container>

      </div>

      <p class="rcc-pdf-report-info__row rcc-pdf-report-info__row--with-top-border">
        {{ rothConvDetailsContent?.percentOfIra }}: <strong>{{ getPercent(inputData.percentOfIra) }}</strong>
      </p>
    </div>

  </div>
</div>
